// extracted by mini-css-extract-plugin
export default {"nav-bar":"Header_nav-bar__nv-Cf","top-p":"Header_top-p__Fy9ZC","tel-icon":"Header_tel-icon__EF1Pw"};